import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

export const Label = memo(({ label, tooltip }) => (
  <S.Label>
    {label}
    <S.LabelTooltip content={<S.TooltipContent>{tooltip}</S.TooltipContent>}>
      <S.Picto />
    </S.LabelTooltip>
  </S.Label>
))

Label.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
}

Label.displayName = 'Label'
